import styled from 'styled-components';

const ButtonWrapper = styled.div`
  display: flex;
`;

ButtonWrapper.displayName = 'ButtonWrapper';

export default ButtonWrapper;
